import React from 'react';
    import { Link, useLocation } from 'react-router-dom';
    import SafeIcon from '../common/SafeIcon';
    import { FiActivity, FiExternalLink } from 'react-icons/fi';

    const Footer = () => {
      const location = useLocation();
      if (location.pathname.startsWith("/admin")) {
        return null;
      }
      return (
        <footer className="bg-[#050505] border-t border-white/5 pt-32 pb-16 px-6">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-20 mb-32">
              <div className="col-span-1 md:col-span-2">
                <div className="flex items-center gap-4 mb-10">
                  <div className="w-10 h-10 border border-[#CCFF00] flex items-center justify-center relative overflow-hidden">
                    <div className="absolute inset-0 bg-[#CCFF00] opacity-10"></div>
                    <SafeIcon icon={FiActivity} className="text-[#CCFF00] text-xl" />
                  </div>
                  <span className="font-black text-2xl tracking-tighter text-white uppercase">The Pitch Feed</span>
                </div>
                
                <div className="space-y-8">
                  <p className="text-slate-500 font-medium text-lg leading-relaxed max-w-sm">
                    Global Football News Agency. We deliver authoritative reporting to sports platforms worldwide.
                  </p>
                  
                  <div className="pt-8 border-t border-white/5 max-w-sm">
                    <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-4 italic">
                      The Pitch Feed is a division of
                    </p>
                    <div className="text-[11px] font-mono-data text-slate-500 uppercase tracking-[0.2em] leading-relaxed">
                      <span className="text-white font-bold block mb-1 uppercase">KonsulentBixen</span>
                      C/O Legaldesk.dk ApS<br />
                      Njalsgade 21 f, 2<br />
                      2300 Copenhagen<br />
                      Denmark
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-[11px] font-black uppercase tracking-[0.4em] text-white mb-10">Information</h3>
                <ul className="space-y-6 text-[10px] font-bold uppercase tracking-[0.2em] text-slate-500">
                  <li>
                    <Link to="/news" className="hover:text-[#CCFF00] transition-colors">News Feed</Link>
                  </li>
                  <li>
                    <Link to="/pricing" className="hover:text-[#CCFF00] transition-colors">Pricing Plans</Link>
                  </li>
                  <li>
                    <Link to="/docs" className="hover:text-[#CCFF00] transition-colors">API Documentation</Link>
                  </li>
                  <li>
                    <Link to="/brand" className="hover:text-[#CCFF00] transition-colors">Brand Guidelines</Link>
                  </li>
                  <li>
                    <Link to="/terms" className="hover:text-[#CCFF00] transition-colors">Terms of Service</Link>
                  </li>
                  <li>
                    <Link to="/cookies" className="hover:text-[#CCFF00] transition-colors">Cookie Policy</Link>
                  </li>
                  <li>
                    <a 
                      href="https://thepitchfeed.uptimekloudfox.com/" 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="hover:text-[#CCFF00] transition-colors flex items-center gap-2"
                    >
                      System Status
                      <SafeIcon icon={FiExternalLink} className="text-[10px]" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="flex flex-col md:flex-row justify-between items-center pt-16 border-t border-white/5 gap-8">
              <p className="text-[9px] font-mono-data uppercase tracking-[0.3em] text-slate-600">
                &copy; {new Date().getFullYear()} THE PITCH FEED. GLOBAL FOOTBALL NEWS AGENCY.
              </p>
            </div>
          </div>
        </footer>
      );
    };

    export default Footer;